export * from './Heading';
export * from './Label';
export * from './Text';

/**
 * @deprecated Use Heading, Label, or Text instead
 */
export * from './LegacyTypography';
